export default __webpack_public_path__ + "static/media/shahrara.8b35eacf.svg";